/**
 * @generated SignedSource<<dc8e87d991fa3d0a0656b1eb680e982b>>
 * @relayHash bba66764bbafcab2a61fad47a47389c3
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 6138908df8b372f8000648922d74b7db5d0149ba7e1fedd3ae15a92cfdda9329

import type { ConcreteRequest, Query } from 'relay-runtime';
export type ContentStateRestrictionLevel = "NONE" | "PAGE_OWNER" | "%future added value";
export type PublicLinkPageStatus = "BLOCKED_BY_CLASSIFICATION_LEVEL" | "BLOCKED_BY_CONTAINER_POLICY" | "BLOCKED_BY_ORG" | "BLOCKED_BY_PRODUCT" | "BLOCKED_BY_SPACE" | "OFF" | "ON" | "SITE_BLOCKED" | "SITE_DISABLED" | "SPACE_BLOCKED" | "SPACE_DISABLED" | "%future added value";
export type preloadLivePageDataQuery$variables = {
  contentId: string;
  isUsdSsr: boolean;
  spaceKey: string;
  userId?: string | null | undefined;
};
export type preloadLivePageDataQuery$data = {
  readonly availableContentStates: {
    readonly customContentStates: ReadonlyArray<{
      readonly color: string;
      readonly id: string | null | undefined;
      readonly name: string;
    } | null | undefined> | null | undefined;
    readonly spaceContentStates: ReadonlyArray<{
      readonly color: string;
      readonly id: string | null | undefined;
      readonly name: string;
      readonly restrictionLevel: ContentStateRestrictionLevel;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly content: {
    readonly nodes: ReadonlyArray<{
      readonly contentProperties: {
        readonly latest: {
          readonly defaultTitleEmoji: string | null | undefined;
        } | null | undefined;
      } | null | undefined;
      readonly contentState: {
        readonly color: string;
        readonly id: string | null | undefined;
        readonly isCallerPermitted: boolean | null | undefined;
        readonly name: string;
        readonly restrictionLevel: ContentStateRestrictionLevel;
      } | null | undefined;
      readonly contentStateLastUpdated: {
        readonly value: string;
      } | null | undefined;
      readonly emojiTitleDraft: {
        readonly nodes: ReadonlyArray<{
          readonly id: string | null | undefined;
          readonly key: string | null | undefined;
          readonly value: string | null | undefined;
          readonly version: {
            readonly number: number | null | undefined;
          } | null | undefined;
        } | null | undefined> | null | undefined;
      } | null | undefined;
      readonly emojiTitlePublished: {
        readonly nodes: ReadonlyArray<{
          readonly id: string | null | undefined;
          readonly key: string | null | undefined;
          readonly value: string | null | undefined;
          readonly version: {
            readonly number: number | null | undefined;
          } | null | undefined;
        } | null | undefined> | null | undefined;
      } | null | undefined;
      readonly id: string | null | undefined;
      readonly labels: {
        readonly nodes: ReadonlyArray<{
          readonly id: string | null | undefined;
          readonly name: string | null | undefined;
        } | null | undefined> | null | undefined;
      } | null | undefined;
      readonly metadata: {
        readonly currentuser: {
          readonly favourited: {
            readonly isFavourite: boolean | null | undefined;
          } | null | undefined;
        } | null | undefined;
        readonly frontend: {
          readonly coverPictureWidth: string | null | undefined;
        } | null | undefined;
      };
      readonly operations: ReadonlyArray<{
        readonly operation: string | null | undefined;
        readonly targetType: string | null | undefined;
      } | null | undefined> | null | undefined;
      readonly properties: {
        readonly nodes: ReadonlyArray<{
          readonly id: string | null | undefined;
          readonly key: string | null | undefined;
          readonly value: string | null | undefined;
          readonly version: {
            readonly number: number | null | undefined;
          } | null | undefined;
        } | null | undefined> | null | undefined;
      } | null | undefined;
      readonly status: string | null | undefined;
      readonly subType: string | null | undefined;
      readonly type: string | null | undefined;
      readonly version: {
        readonly by: {
          readonly accountId?: string | null | undefined;
          readonly type: string | null | undefined;
        } | null | undefined;
        readonly ncsStepVersion: string | null | undefined;
        readonly number: number | null | undefined;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly publicLinkPage?: {
    readonly pageId: string;
    readonly pageStatus: PublicLinkPageStatus;
  } | null | undefined;
  readonly space: {
    readonly id: string | null | undefined;
    readonly settings: {
      readonly customHeaderAndFooter: {
        readonly footer: {
          readonly css: string;
          readonly html: string;
          readonly js: ReadonlyArray<string | null | undefined>;
          readonly spaUnfriendlyMacros: ReadonlyArray<{
            readonly name: string | null | undefined;
          }>;
        };
        readonly header: {
          readonly css: string;
          readonly html: string;
          readonly js: ReadonlyArray<string | null | undefined>;
          readonly spaUnfriendlyMacros: ReadonlyArray<{
            readonly name: string | null | undefined;
          }>;
        };
      };
    } | null | undefined;
  } | null | undefined;
  readonly user: {
    readonly displayName: string | null | undefined;
    readonly id: string | null | undefined;
    readonly photos: ReadonlyArray<{
      readonly isPrimary: boolean | null | undefined;
      readonly value: string | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
};
export type preloadLivePageDataQuery = {
  response: preloadLivePageDataQuery$data;
  variables: preloadLivePageDataQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contentId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isUsdSsr"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "spaceKey"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "userId"
},
v4 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "contentId"
  },
  {
    "kind": "Literal",
    "name": "status",
    "value": [
      "current",
      "draft"
    ]
  }
],
v5 = {
  "kind": "ScalarField",
  "name": "id"
},
v6 = {
  "kind": "ScalarField",
  "name": "status"
},
v7 = {
  "kind": "ScalarField",
  "name": "type"
},
v8 = {
  "kind": "ScalarField",
  "name": "value"
},
v9 = {
  "kind": "ScalarField",
  "name": "number"
},
v10 = [
  {
    "concreteType": "JsonContentProperty",
    "kind": "LinkedField",
    "name": "nodes",
    "plural": true,
    "selections": [
      (v5/*: any*/),
      {
        "kind": "ScalarField",
        "name": "key"
      },
      (v8/*: any*/),
      {
        "concreteType": "Version",
        "kind": "LinkedField",
        "name": "version",
        "plural": false,
        "selections": [
          (v9/*: any*/)
        ]
      }
    ]
  }
],
v11 = {
  "alias": "emojiTitlePublished",
  "args": [
    {
      "kind": "Literal",
      "name": "key",
      "value": "emoji-title-published"
    }
  ],
  "concreteType": "PaginatedJsonContentPropertyList",
  "kind": "LinkedField",
  "name": "properties",
  "plural": false,
  "selections": (v10/*: any*/),
  "storageKey": "properties(key:\"emoji-title-published\")"
},
v12 = {
  "alias": "emojiTitleDraft",
  "args": [
    {
      "kind": "Literal",
      "name": "key",
      "value": "emoji-title-draft"
    }
  ],
  "concreteType": "PaginatedJsonContentPropertyList",
  "kind": "LinkedField",
  "name": "properties",
  "plural": false,
  "selections": (v10/*: any*/),
  "storageKey": "properties(key:\"emoji-title-draft\")"
},
v13 = {
  "concreteType": "ContentProperties",
  "kind": "LinkedField",
  "name": "contentProperties",
  "plural": false,
  "selections": [
    {
      "concreteType": "PublishedContentProperties",
      "kind": "LinkedField",
      "name": "latest",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "defaultTitleEmoji"
        }
      ]
    }
  ]
},
v14 = {
  "args": [
    {
      "kind": "Literal",
      "name": "key",
      "value": "content-appearance-draft"
    }
  ],
  "concreteType": "PaginatedJsonContentPropertyList",
  "kind": "LinkedField",
  "name": "properties",
  "plural": false,
  "selections": (v10/*: any*/),
  "storageKey": "properties(key:\"content-appearance-draft\")"
},
v15 = {
  "concreteType": "ContentMetadata",
  "kind": "LinkedField",
  "name": "metadata",
  "plural": false,
  "selections": [
    {
      "concreteType": "ContentMetadata_SpaFriendlyMetadataProvider_frontend",
      "kind": "LinkedField",
      "name": "frontend",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "coverPictureWidth"
        }
      ]
    },
    {
      "concreteType": "ContentMetadata_CurrentUserMetadataProvider_currentuser",
      "kind": "LinkedField",
      "name": "currentuser",
      "plural": false,
      "selections": [
        {
          "concreteType": "FavouritedSummary",
          "kind": "LinkedField",
          "name": "favourited",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "isFavourite"
            }
          ]
        }
      ]
    }
  ]
},
v16 = {
  "kind": "ScalarField",
  "name": "name"
},
v17 = {
  "kind": "ScalarField",
  "name": "color"
},
v18 = {
  "kind": "ScalarField",
  "name": "restrictionLevel"
},
v19 = {
  "args": [
    {
      "kind": "Literal",
      "name": "isDraft",
      "value": false
    }
  ],
  "concreteType": "ContentState",
  "kind": "LinkedField",
  "name": "contentState",
  "plural": false,
  "selections": [
    (v5/*: any*/),
    (v16/*: any*/),
    (v17/*: any*/),
    (v18/*: any*/),
    {
      "kind": "ScalarField",
      "name": "isCallerPermitted"
    }
  ],
  "storageKey": "contentState(isDraft:false)"
},
v20 = {
  "args": [
    {
      "kind": "Literal",
      "name": "format",
      "value": "USER_FRIENDLY"
    }
  ],
  "concreteType": "ConfluenceDate",
  "kind": "LinkedField",
  "name": "contentStateLastUpdated",
  "plural": false,
  "selections": [
    (v8/*: any*/)
  ],
  "storageKey": "contentStateLastUpdated(format:\"USER_FRIENDLY\")"
},
v21 = {
  "concreteType": "OperationCheckResult",
  "kind": "LinkedField",
  "name": "operations",
  "plural": true,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "operation"
    },
    {
      "kind": "ScalarField",
      "name": "targetType"
    }
  ]
},
v22 = {
  "kind": "ScalarField",
  "name": "subType"
},
v23 = {
  "kind": "ScalarField",
  "name": "ncsStepVersion"
},
v24 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "accountId"
    }
  ],
  "type": "KnownUser"
},
v25 = {
  "concreteType": "PaginatedLabelList",
  "kind": "LinkedField",
  "name": "labels",
  "plural": false,
  "selections": [
    {
      "concreteType": "Label",
      "kind": "LinkedField",
      "name": "nodes",
      "plural": true,
      "selections": [
        (v5/*: any*/),
        (v16/*: any*/)
      ]
    }
  ]
},
v26 = [
  {
    "kind": "ScalarField",
    "name": "html"
  },
  {
    "kind": "ScalarField",
    "name": "js"
  },
  {
    "kind": "ScalarField",
    "name": "css"
  },
  {
    "concreteType": "SpaUnfriendlyMacro",
    "kind": "LinkedField",
    "name": "spaUnfriendlyMacros",
    "plural": true,
    "selections": [
      (v16/*: any*/)
    ]
  }
],
v27 = {
  "args": [
    {
      "kind": "Variable",
      "name": "key",
      "variableName": "spaceKey"
    }
  ],
  "concreteType": "Space",
  "kind": "LinkedField",
  "name": "space",
  "plural": false,
  "selections": [
    (v5/*: any*/),
    {
      "concreteType": "SpaceSettings",
      "kind": "LinkedField",
      "name": "settings",
      "plural": false,
      "selections": [
        {
          "concreteType": "SpaceSettingsMetadata",
          "kind": "LinkedField",
          "name": "customHeaderAndFooter",
          "plural": false,
          "selections": [
            {
              "concreteType": "HtmlMeta",
              "kind": "LinkedField",
              "name": "header",
              "plural": false,
              "selections": (v26/*: any*/)
            },
            {
              "concreteType": "HtmlMeta",
              "kind": "LinkedField",
              "name": "footer",
              "plural": false,
              "selections": (v26/*: any*/)
            }
          ]
        }
      ]
    }
  ]
},
v28 = {
  "args": [
    {
      "kind": "Variable",
      "name": "contentId",
      "variableName": "contentId"
    }
  ],
  "concreteType": "AvailableContentStates",
  "kind": "LinkedField",
  "name": "availableContentStates",
  "plural": false,
  "selections": [
    {
      "concreteType": "ContentState",
      "kind": "LinkedField",
      "name": "customContentStates",
      "plural": true,
      "selections": [
        (v16/*: any*/),
        (v17/*: any*/),
        (v5/*: any*/)
      ]
    },
    {
      "concreteType": "ContentState",
      "kind": "LinkedField",
      "name": "spaceContentStates",
      "plural": true,
      "selections": [
        (v16/*: any*/),
        (v17/*: any*/),
        (v5/*: any*/),
        (v18/*: any*/)
      ]
    }
  ]
},
v29 = {
  "condition": "isUsdSsr",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "pageId",
          "variableName": "contentId"
        }
      ],
      "concreteType": "PublicLinkPage",
      "kind": "LinkedField",
      "name": "publicLinkPage",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "pageId"
        },
        {
          "kind": "ScalarField",
          "name": "pageStatus"
        }
      ]
    }
  ]
},
v30 = {
  "alias": "user",
  "args": [
    {
      "kind": "Variable",
      "name": "id",
      "variableName": "userId"
    }
  ],
  "concreteType": "AtlassianUser",
  "kind": "LinkedField",
  "name": "confluence_atlassianUser",
  "plural": false,
  "selections": [
    (v5/*: any*/),
    {
      "kind": "ScalarField",
      "name": "displayName"
    },
    {
      "concreteType": "AtlassianUserPhoto",
      "kind": "LinkedField",
      "name": "photos",
      "plural": true,
      "selections": [
        (v8/*: any*/),
        {
          "kind": "ScalarField",
          "name": "isPrimary"
        }
      ]
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "name": "preloadLivePageDataQuery",
    "selections": [
      {
        "args": (v4/*: any*/),
        "concreteType": "PaginatedContentListWithChild",
        "kind": "LinkedField",
        "name": "content",
        "plural": false,
        "selections": [
          {
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/),
              (v13/*: any*/),
              (v14/*: any*/),
              (v15/*: any*/),
              (v19/*: any*/),
              (v20/*: any*/),
              (v21/*: any*/),
              (v22/*: any*/),
              {
                "concreteType": "Version",
                "kind": "LinkedField",
                "name": "version",
                "plural": false,
                "selections": [
                  (v9/*: any*/),
                  (v23/*: any*/),
                  {
                    "kind": "LinkedField",
                    "name": "by",
                    "plural": false,
                    "selections": [
                      (v7/*: any*/),
                      (v24/*: any*/)
                    ]
                  }
                ]
              },
              (v25/*: any*/)
            ]
          }
        ]
      },
      (v27/*: any*/),
      (v28/*: any*/),
      (v29/*: any*/),
      (v30/*: any*/)
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v3/*: any*/),
      (v0/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "preloadLivePageDataQuery",
    "selections": [
      {
        "args": (v4/*: any*/),
        "concreteType": "PaginatedContentListWithChild",
        "kind": "LinkedField",
        "name": "content",
        "plural": false,
        "selections": [
          {
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/),
              (v13/*: any*/),
              (v14/*: any*/),
              (v15/*: any*/),
              (v19/*: any*/),
              (v20/*: any*/),
              (v21/*: any*/),
              (v22/*: any*/),
              {
                "concreteType": "Version",
                "kind": "LinkedField",
                "name": "version",
                "plural": false,
                "selections": [
                  (v9/*: any*/),
                  (v23/*: any*/),
                  {
                    "kind": "LinkedField",
                    "name": "by",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "__typename"
                      },
                      (v7/*: any*/),
                      (v24/*: any*/)
                    ]
                  }
                ]
              },
              (v25/*: any*/)
            ]
          }
        ]
      },
      (v27/*: any*/),
      (v28/*: any*/),
      (v29/*: any*/),
      (v30/*: any*/)
    ]
  },
  "params": {
    "cacheID": "bba66764bbafcab2a61fad47a47389c3",
    "id": "6138908df8b372f8000648922d74b7db5d0149ba7e1fedd3ae15a92cfdda9329",
    "metadata": {},
    "name": "preloadLivePageDataQuery",
    "operationKind": "query",
    "text": "query preloadLivePageDataQuery($userId:ID,$contentId:ID!,$spaceKey:String!,$isUsdSsr:Boolean!){content(id:$contentId,status:[\"current\",\"draft\"]){nodes{id,status,type,emojiTitlePublished:properties(key:\"emoji-title-published\"){nodes{id,key,value,version{number}}},emojiTitleDraft:properties(key:\"emoji-title-draft\"){nodes{id,key,value,version{number}}},contentProperties{latest{defaultTitleEmoji}},properties(key:\"content-appearance-draft\"){nodes{id,key,value,version{number}}},metadata{frontend{coverPictureWidth},currentuser{favourited{isFavourite}}},contentState(isDraft:false){id,name,color,restrictionLevel,isCallerPermitted},contentStateLastUpdated(format:USER_FRIENDLY){value},operations{operation,targetType},subType,version{number,ncsStepVersion,by{__typename,type,...on KnownUser{accountId}}},labels{nodes{id,name}}}},space(key:$spaceKey){id,settings{customHeaderAndFooter{header{html,js,css,spaUnfriendlyMacros{name}},footer{html,js,css,spaUnfriendlyMacros{name}}}}},availableContentStates(contentId:$contentId){customContentStates{name,color,id},spaceContentStates{name,color,id,restrictionLevel}},publicLinkPage(pageId:$contentId)@include(if:$isUsdSsr){pageId,pageStatus},user:confluence_atlassianUser(id:$userId){id,displayName,photos{value,isPrimary}}}"
  }
};
})();

(node as any).hash = "fc27c69a6916f3d6cce88a681314b6ab";

export default node;
